export type SiteThemeOption = {
    label: string;
    value: string;
};

/**
 * Design flavors stored in CDM site.theme.
 * WordPress always activates astra-child; these select content/style variants.
 */
export const SITE_THEME_OPTIONS: SiteThemeOption[] = [
    { label: 'Default', value: 'default' },
    { label: 'Slick', value: 'slick' },
];

export const DEFAULT_SITE_THEME = 'default';

/** Normalize API/legacy values (e.g. astra-child) to default | slick. */
export function normalizeSiteTheme(theme: string | null | undefined): string {
    if (theme === 'slick') {
        return 'slick';
    }
    return DEFAULT_SITE_THEME;
}

export function getSiteThemeLabel(theme: string | null | undefined): string {
    const normalized = normalizeSiteTheme(theme);
    return SITE_THEME_OPTIONS.find((option) => option.value === normalized)?.label ?? normalized;
}
